const swiper_full_tate = new Swiper(".slide_full_tate", {
  // Optional parameters
  direction: "vertical",
  loop: false,
  effect: "slide",
  slidesPerView: 1,
  speed: 600,
  mousewheel: true,

  // If we need pagination
  pagination: {
    el: ".swiper-pagination",
  },

  // Navigation arrows
  //   navigation: {
  //     nextEl: ".swiper-button-next",
  //     prevEl: ".swiper-button-prev",
  //   },

  // And if we need scrollbar
  //   scrollbar: {
  //     el: ".swiper-scrollbar",
  //   },
});

const swiper_full_wide = new Swiper(".slide_full_wide", {
  // Optional parameters
  loop: true,
  speed: 1500,
  effect: "fade",
  autoplay: {
    delay: 3000,
  },
  // If we need pagination
  pagination: {
    el: ".swiper-pagination",
  },
  slidesPerView: 1,
  centeredSlides: false,

//   Navigation arrows
//   navigation: {
//     nextEl: ".swiper-button-next",
//     prevEl: ".swiper-button-prev",
//   },
});

const swiper_yoko_card = new Swiper(".slide_yoko_card", {
  // Optional parameters
  loop: true,
  speed: 1000,

  slidesPerView: 1.5,

  breakpoints: {
    500: {
      slidesPerView: 2,
    },
    800: {
      slidesPerView: 3,
    },
  },
  // If we need pagination
  pagination: {
    el: ".swiper-pagination",
  },
  slidesPerView: 1,
  centeredSlides: false,

  // Navigation arrows
  navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
});

const swiper_full_wide_product = new Swiper(".slide_full_wide_product", {
  // Optional parameters
  loop: true,
  speed: 1500,
  effect: "fade",
  autoplay: {
    delay: 3000,
  },
  // If we need pagination
  pagination: {
    el: ".swiper-pagination",
  },
  slidesPerView: 1,
  centeredSlides: false,

  //Navigation arrows
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
const swiper_full_wide_product_mini = new Swiper(".slide_full_wide_product_mini", {
  // Optional parameters
  loop: true,
  speed: 1500,
  effect: "fade",
  autoplay: {
    delay: 3000,
  },
  // If we need pagination
  pagination: {
    el: ".swiper-pagination",
  },
  slidesPerView: 1,
  centeredSlides: false,

  //Navigation arrows
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
const swiper_full_wide_product_top = new Swiper(".slide_full_wide_product_top", {
  // Optional parameters
  loop: true,
  speed: 1500,
  effect: "fade",
  autoplay: {
    delay: 3000,
  },
  // If we need pagination
  pagination: {
    el: ".swiper-pagination",
  },
  slidesPerView: 1,
  centeredSlides: false,

  //Navigation arrows
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
